<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMesMstKamListResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName"
                                      ref="emTable" exportDisabled :inlineActionsDisabled="prop_inline!=='1'"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template #left-header>
                                    <em-button type="edit"
                                               :disabled="actionDisabled('select')"
                                               custom-label="设置P/非P"
                                               :showName="true"
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               @click="openSetPDialog()"
                                    >
                                    </em-button>
                                    <em-button type="edit"
                                               :disabled="actionDisabled('select')"
                                               custom-label="设置物料去向"
                                               :showName="true"
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               @click="openSetMaterialDirDialog()"
                                    >
                                    </em-button>
                                    <em-button type="edit"
                                               :disabled="actionDisabled('select')"
                                               custom-label="设置物料供货范围"
                                               :showName="true"
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               @click="openSetScopeDialog()"
                                    >
                                    </em-button>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
        <el-dialog title="设置P/!P" width="30%" :visible.sync="pDialogVisible" :close-on-click-modal='false' append-to-body
                   @close='clearPDirection'>
            <el-select v-model="pDirection" placeholder="请选择">
                <el-option v-for="dir in directionOptions" :key="dir.value" :label="dir.label" :value="dir.value">

                </el-option>
            </el-select>
            <div slot="footer" class="dialog-footer">
                <el-button @click="pDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="setPDirection()">确认</el-button>
            </div>
        </el-dialog>

        <el-dialog title="设置物料去向" width="30%" :visible.sync="matDirDialogVisible" :close-on-click-modal='false' append-to-body
                   @close='clearMatDirection'>
            <el-select v-model="matDirection" placeholder="请选择">
                <el-option v-for="dir in matDirectionOptions" :key="dir.value" :label="dir.label"
                           :value="dir.value"></el-option>
            </el-select>
            <div slot="footer" class="dialog-footer">
                <el-button @click="matDirDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="setMaterialDirection()">确认</el-button>
            </div>
        </el-dialog>

        <el-dialog title="设置物料供货范围" width="30%" :visible.sync="scopeDialogVisible" :close-on-click-modal='false' append-to-body
                   @close='clearScope'>
            <el-select v-model="scope" placeholder="请选择">
                <el-option v-for="scope in scopeOptions" :key="scope.value" :label="scope.label" :value="scope.value">

                </el-option>
            </el-select>
            <div slot="footer" class="dialog-footer">
                <el-button @click="scopeDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="setScope()">确认</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
// Author Lin
// Date 2021-08-04 16:32:23

import emCommonListMixin from "@/mixin/em/common/list";
import emCommonApiMixin from "@/mixin/em/common/api";

export default {
    name: "sithMesMstKamListListView",
    mixins: [emCommonListMixin, emCommonApiMixin],
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        }
    },
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        },
        checkedItems() {
            //这里要注意，如果filter和table使用了customVuex，这里要用checkedItems拼装首字母开头的customVuex name。不使用$refs.emTable是因为初始化时取不到，会报错
            return this.$store.state[this.modelName]["checkedItems"];
        },
        selectIds() {
            //这里要注意，如果filter和table使用了customVuex，这里要用checkedItems拼装首字母开头的customVuex name。不使用$refs.emTable是因为初始化时取不到，会报错
            return this.$store.state[this.modelName]["checkedItems"].join(",");
        },
    },
    data() {
        return {
            pDialogVisible: false,
            matDirDialogVisible: false,
            scopeDialogVisible: false,
            pDirection: '',
            directionOptions: [{
                value: true,
                label: "P"
            }, {
                value: false,
                label: "!P"
            }],
            matDirection: '',
            matDirectionOptions: [{
                value: 1,
                label: "R"
            }, {
                value: 2,
                label: "3rd"
            }],
            scope: '',
            scopeOptions: [{
                value: 1,
                label: "SAG"
            }, {
                value: 2,
                label: "SITH"
            }, {
                value: 3,
                label: "MIXED"
            }],
        }
    },
    methods: {
        actionDisabled(type) {
            // 删除按钮在一条记录都没选的时候禁用
            if (type === "select") {
                return this.checkedItems && this.checkedItems.length === 0;
            }
            // 编辑按钮只在选择了1条记录的时候可用，其他情况下禁用
            else if (type === "selectOne") {
                return this.checkedItems && this.checkedItems.length !== 1;
            }
        },
        openSetPDialog() {
            this.pDialogVisible = true;
        },
        openSetMaterialDirDialog() {
            this.matDirDialogVisible = true;
        },
        openSetScopeDialog() {
            this.scopeDialogVisible = true;
        },
        clearPDirection() {
            this.pDirection = ''
        },
        clearMatDirection() {
            this.matDirection = ''
        },
        clearScope() {
            this.scope = ''
        },
        setPDirection() {
            let self = this;
            let url = `${this.$_emApiMixin_entityBaseApi(this.modelName)}/setPDirection?ids=${this.selectIds}&direction=${this.pDirection}`;
            this.$_emApiMixin_post(url, {})
                .then((request) => {
                    if (request.status === 200) {
                        self.$message({
                            message: "设置成功",
                            type: "success",
                        });

                        self.$refs.emListFilter.doQuery();
                    } else {
                        self.$message({
                            message: "设置失败",
                            type: "error",
                        });
                    }
                }).finally(() => {
                this.pDialogVisible = false;
            })
        },
        setMaterialDirection() {
            let self = this;
            let url = `${this.$_emApiMixin_entityBaseApi(this.modelName)}/setMaterialDirection?ids=${this.selectIds}&direction=${this.matDirection}`;
            this.$_emApiMixin_post(url, {})
                .then((request) => {
                    if (request.status === 200) {
                        self.$message({
                            message: "设置成功",
                            type: "success",
                        });

                        self.$refs.emListFilter.doQuery();
                    } else {
                        self.$message({
                            message: "设置失败",
                            type: "error",
                        });
                    }
                }).finally(() => {
                this.matDirDialogVisible = false;
            })
        },
        setScope() {
            let self = this;
            let url = `${this.$_emApiMixin_entityBaseApi(this.modelName)}/setScope?ids=${this.selectIds}&scope=${this.scope}`;
            this.$_emApiMixin_post(url, {})
                .then((request) => {
                    if (request.status === 200) {
                        self.$message({
                            message: "设置成功",
                            type: "success",
                        });

                        self.$refs.emListFilter.doQuery();
                    } else {
                        self.$message({
                            message: "设置失败",
                            type: "error",
                        });
                    }
                }).finally(() => {
                this.scopeDialogVisible = false;
            })
        }
    }
};
</script>
